/** @flow */
import * as React from 'react';
import styled from 'styled-components';
import Button from '@material-ui/core/Button';

/** Custom import's */
import t from '../../../application/translate';
import SvgIcon from '../../SvgIcon/SvgIcon';
import rightIcon from '../../SvgIcon/rightIcon';

const { Component } = React;

const Result = styled.div.attrs({
  className: 'text-center text-3xl font-semibold px-4 pb-3 text-green bg-grey-bg',
})``;

const ButtonDiv = styled.div.attrs({
  className: 'text-center text-grey mx-auto',
})`
  width: 100%;
  padding: 0 40px;
  padding-bottom: 90px;
  @media screen and (min-width: 425px) {
    width: 340px;
    padding: 0;
  }
`;

const StyledButton = styled(({ ...rest }) => (
  <Button {...rest} classes={{ label: 'label' }} />
))`
  .label {
    font-size: 22px;
    font-family: 'Quicksand', sans-serif;
    font-weight: 600;
    text-transform: none;
    display: inline-block;
    line-height: 20px;
  }

  svg {
    float: right;
  }

  && {
    width: 100%;
    height: 60px;
    background-color: #00b426;
    border-radius: 10px;
    padding: 0 40px;
    margin-top: 28px;
    margin-bottom: 40px;
    box-shadow: none;
    align-self: center;
    @media screen and (min-width: 425px) {
      width: 260px;
    }
    @media screen and (max-width: 580px) {
      margin-bottom: 50px;
    }

  }

  &&&:hover {
    background-color: #00b426;
  }
`;
const StyledA = styled.a`
& {
  text-decoration: none !important;
}
`;

class Result3 extends Component<Props & ProvidedProps, State> {

  render() {

    return (
      <div>
        <Result>{t('visaCheckingForm/result3/part1')}</Result>
        <Result>{t('visaCheckingForm/result3/part2')}</Result>
        <ButtonDiv>
          <StyledA href={t('path/visaInsurance')}>
            <StyledButton variant="raised" color="primary" type='submit' >
              {t('visaCheckingForm/button')} <SvgIcon svgIcon={rightIcon} />
            </StyledButton>
          </StyledA>
          <div>{t('visaCheckingForm/info')}</div>
        </ButtonDiv>
      </div>
    );
  }

}

export default Result3;



// WEBPACK FOOTER //
// ./src/components/VisaCheckingForm/results/Result3.js